import React from "react";
import { Route, Routes } from "react-router-dom"; // Cleaned up imports
import ExamLogin from "./../../components/screens/attendExam/ExamLogin";
import Index from "../../components/screens/dashboard/Index";
import Questions from "../../components/screens/attendExam/Questions";
import InstructionMainPage from "../../components/screens/attendExam/InstructionMainPage";
import Login from "../../components/screens/login/Login";
import "../../assets/css/style.css";
import MainDashboard2 from "../../components/screens/dashboard/MainDashboard2";

function AppRouter() {
    return (
        <Routes>
			<Route path="/*" element={<Index />} />
            <Route path="/exam-login/:subject_id" element={<ExamLogin />} />
            <Route
                path="/exam-instruction/:id"
                element={<InstructionMainPage />}
            />
            <Route path="/exam-questions/:id" element={<Questions />} />
            {/* A catch-all route for any unhandled paths */}
            <Route path="*" element={<> Page not Found </>} />

            {/* Your commented-out login route */}
            {/* <Route path="/login/" element={<Login />} /> */}
        </Routes>
    );
}

export default AppRouter;